import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.SET_TRACKING_STATUS_BEHANDLE_HISTORIES:
      return { ...action.data };
    default: return state;
  }
};
